'use strict';

(function () {

    var root = document.documentElement;
    var REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal() {
        root.classList.remove('is-pre-anim');
    }

    if (!window.gsap || REDUCE_MOTION) {
        reveal();
        return;
    }

    var gsap = window.gsap;

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    var topbar = $('.topbar');
    var logo = $('.wordmark__img');
    var bar = $('.bar');
    var headline = $('.headline');
    var subline = $('.subline');
    var signup = $('.signup');
    var rgpd = $('.rgpd');
    var motto = $('.motto');
    var socials = $$('.social__link');
    var bottombar = $('.bottombar');
    var okStatus = $('.status--ok');
    var group = $('#signup-group');

    function splitWords(el) {
        if (!el) return [];
        var text = el.textContent.trim();
        var words = text.split(/\s+/);
        el.setAttribute('aria-label', text);
        el.textContent = '';
        return words.map(function (word, i) {
            var mask = document.createElement('span');
            mask.className = 'headline__mask';
            mask.setAttribute('aria-hidden', 'true');
            var inner = document.createElement('span');
            inner.className = 'headline__word';
            inner.textContent = word;
            mask.appendChild(inner);
            el.appendChild(mask);
            if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
            return inner;
        });
    }

    var words = splitWords(headline);

    gsap.set([topbar, bottombar], { autoAlpha: 0, y: -8 });
    gsap.set(bottombar, { y: 8 });
    gsap.set(logo, { autoAlpha: 0, scale: 0.82, skewX: 10, transformOrigin: '50% 50%' });
    gsap.set(bar, { scaleX: 0, transformOrigin: '0% 50%' });
    gsap.set(words, { yPercent: 115 });
    gsap.set([subline, signup, rgpd, motto], { autoAlpha: 0, y: 14 });
    gsap.set(socials, { autoAlpha: 0, y: 14 });
    gsap.set(root, { '--grid-opacity': 0 });

    reveal();

    var intro = gsap.timeline({ defaults: { ease: 'power4.out' } });

    intro
        .to(root, { '--grid-opacity': 0.22, duration: 1.6, ease: 'power2.out' }, 0)
        .to(topbar, { autoAlpha: 1, y: 0, duration: 0.6 }, 0.1)
        .to(logo, { autoAlpha: 1, scale: 1, skewX: 0, duration: 1.0, ease: 'expo.out' }, 0.15)
        .fromTo(logo,
            { filter: 'drop-shadow(0 0 0 rgba(193, 18, 31, 0)) brightness(1.6)' },
            { filter: 'drop-shadow(0 12px 28px rgba(193, 18, 31, 0.28)) brightness(1)', duration: 0.9, ease: 'power2.out' },
            0.25)
        .to(bar, { scaleX: 1, duration: 0.55, ease: 'power3.inOut' }, 0.55)
        .to(words, { yPercent: 0, duration: 0.75, stagger: 0.07 }, 0.7)
        .to(subline, { autoAlpha: 1, y: 0, duration: 0.6 }, 0.95)
        .to(signup, { autoAlpha: 1, y: 0, duration: 0.6 }, 1.05)
        .to(rgpd, { autoAlpha: 1, y: 0, duration: 0.5 }, 1.2)
        .to(motto, { autoAlpha: 1, y: 0, duration: 0.5 }, 1.3)
        .to(socials, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.08 }, 1.35)
        .to(bottombar, { autoAlpha: 1, y: 0, duration: 0.5 }, 1.45)
        .add(startIdle, 1.2);

    function startIdle() {
        if (logo) {
            gsap.to(logo, { y: -7, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1 });
        }
        gsap.to(root, { '--grid-shift': '120px', duration: 40, ease: 'none', repeat: -1 });
        if (motto) {
            gsap.to(motto, { letterSpacing: '0.5em', duration: 4, ease: 'sine.inOut', yoyo: true, repeat: -1 });
        }
        setupParallax();
    }

    function setupParallax() {
        if (!logo) return;
        var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (!canHover) return;
        var toX = gsap.quickTo(logo, 'x', { duration: 0.8, ease: 'power3.out' });
        var toRotY = gsap.quickTo(logo, 'rotationY', { duration: 0.8, ease: 'power3.out' });
        var toRotX = gsap.quickTo(logo, 'rotationX', { duration: 0.8, ease: 'power3.out' });
        gsap.set(logo, { transformPerspective: 900 });
        window.addEventListener('pointermove', function (e) {
            var nx = (e.clientX / window.innerWidth) - 0.5;
            var ny = (e.clientY / window.innerHeight) - 0.5;
            toX(nx * 18);
            toRotY(nx * 10);
            toRotX(-ny * 8);
        }, { passive: true });
        window.addEventListener('pointerleave', function () {
            toX(0); toRotY(0); toRotX(0);
        });
    }

    if (okStatus) {
        gsap.from(okStatus, { scale: 0.92, autoAlpha: 0, duration: 0.6, ease: 'back.out(1.8)', delay: 1.05 });
        gsap.fromTo(okStatus,
            { boxShadow: '0 0 0 0 rgba(193, 18, 31, 0.6)' },
            { boxShadow: '0 0 0 18px rgba(193, 18, 31, 0)', duration: 1.2, ease: 'power2.out', delay: 1.3 });
    }

    document.addEventListener('maintenance:invalid', function () {
        if (!group) return;
        gsap.fromTo(group, { x: -6 }, { x: 0, duration: 0.45, ease: 'elastic.out(1, 0.3)' });
    });

    document.addEventListener('maintenance:submitting', function () {
        var btn = $('#signup-submit');
        if (btn) gsap.to(btn, { scale: 0.97, duration: 0.15, yoyo: true, repeat: 1, ease: 'power2.inOut' });
    });

    socials.forEach(function (link) {
        link.addEventListener('pointerenter', function () {
            gsap.fromTo(link, { x: 0 }, { x: -2, duration: 0.12, yoyo: true, repeat: 1, ease: 'power1.inOut' });
        });
    });

    var modal = $('#privacy-modal');
    if (modal) {
        var panel = $('.modal__panel', modal);
        var observer = new MutationObserver(function () {
            if (!modal.hasAttribute('hidden') && panel) {
                gsap.fromTo(modal, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.25, ease: 'power2.out', clearProps: 'visibility' });
                gsap.fromTo(panel, { y: 18, scale: 0.98 }, { y: 0, scale: 1, duration: 0.4, ease: 'power3.out' });
            }
        });
        observer.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    }
})();
